var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var LinkingManager = require('./wrappers/LinkingManager');

var {
  View,
  StyleSheet,
} = ReactNative;

var ExternalLink = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {

    }
  },

  getInitialState : function()
  {
    return {

    }
  },

  componentDidMount : function()
  {
  },

  componentWillUnmount : function()
  {
  },

  didUpdate : function(data)
  {

  },

  render: function()
  {
    return (<View />)
  }
});

ExternalLink.getCards = function(featureData, appActions, data)
{
  var didSelect = function()
  {
    ExternalLink.customNavigation(featureData, appActions);
  };

  var appManager = appActions._appManager;
  var iconName = featureData.data.icon.replace("fa-", "")
  var feedSortOrderOffset = featureData.data.feedSortOrder;
  var feedSortOrder = 0;
  if( typeof appManager !== 'undefined' )
  {
    feedSortOrder = ( (new Date()).getTime() - appManager.externalLinkDateForFeatureName(featureData.data.name) ) + feedSortOrderOffset;
  }

  return [{
    didSelect : didSelect,
    title : featureData.data.title,
    body1 : featureData.data.tip,
    icon : iconName,
    cardType : 0,
    sortOrder : feedSortOrder,
  }];
}

ExternalLink.customNavigation = function(featureData, appActions)
{
  var url = featureData.data.url;
  if( url.search("http") != 0 ) url = "http://" + url;

  var appManager = appActions._appManager;
  var barTintColor = appManager.getColorForKey("HeaderColor");
  var tintColor = appManager.getColorForKey("HeaderIconColor");

  LinkingManager.openURL(url, tintColor, barTintColor);
}

ExternalLink.dataDependencies = [];

module.exports = ExternalLink;
